import React from 'react';

import { changeDateFormat, onGetLocalFromUtc } from '@utils/Util';

const APPROVAL_EVENT_LABELS = {
	SENT_FOR_APPROVAL: 'Sent for approval',
	APPROVED: 'Approved'
};

const getEventActorNames = (item) => {
	if (item?.approvalEventType === 'APPROVED' && item?.approvedByResponses?.length) {
		return item.approvedByResponses
			.map((approver) => approver.name)
			.filter(Boolean)
			.join(', ');
	}
	return item?.changedByResponse?.name;
};

const getEventTimeLabel = (item) => {
	const localTime = onGetLocalFromUtc(item?.changeAt, 'Do MMM, YYYY, h:mm A');
	const eventLabel = APPROVAL_EVENT_LABELS[item?.approvalEventType];
	return eventLabel ? `${eventLabel}, on: ${localTime}` : `On ${localTime}`;
};

// Plain "On <date>" updates first, then approval events, grouped by day.
const getGroupedTimeline = (timelineData) => {
	const list = timelineData ?? [];
	const isApproval = (item) => Boolean(APPROVAL_EVENT_LABELS[item?.approvalEventType]);

	return [...list.filter((item) => !isApproval(item)), ...list.filter(isApproval)].reduce(
		(groups, item) => {
			const dateLabel = onGetLocalFromUtc(item?.changeAt, 'DD MMM');
			const lastGroup = groups[groups.length - 1];
			if (lastGroup?.dateLabel === dateLabel) lastGroup.items.push(item);
			else groups.push({ dateLabel, items: [item] });
			return groups;
		},
		[]
	);
};

const EtdUpdateTimeline = ({ timelineData }) => {
	const groupedTimeline = getGroupedTimeline(timelineData);

	return (
		<div className="design-timeline-container scroll-y-label">
			<ul className="design-timeline design-timeline-centered">
				{groupedTimeline.map((group) => (
					<React.Fragment key={`${group.dateLabel}-${group.items[0]?.id}`}>
						<li className="design-timeline-date regular-12 gray_dark_02">{group.dateLabel}</li>
						{group.items.map((item) => (
							<li className="design-timeline-item status purple-1" key={item?.id}>
								<div className="design-timeline-marker"></div>
								<div className="design-timeline-content">
									<p className="regular-14">{getEventActorNames(item)}</p>
									<span
										className={`etd-event-time regular-12 ${
											item?.approvalEventType?.toLowerCase() || ''
										}`}
									>
										{getEventTimeLabel(item)}
									</span>
									<span className="etd-timeline-detail regular-12">
										<span className="gray_dark_02">ETD:</span>{' '}
										{changeDateFormat(item?.oldValue, 'YYYY-MM-DD', 'DD-MMM-YYYY')}
										{' -> '}
										{changeDateFormat(item?.newValue, 'YYYY-MM-DD', 'DD-MMM-YYYY')}
									</span>
								</div>
							</li>
						))}
					</React.Fragment>
				))}
			</ul>
		</div>
	);
};

export default EtdUpdateTimeline;
